// extracted by mini-css-extract-plugin
module.exports = {"bigA":"Breadcrumbs_bigA__1gwpQ","smallA":"Breadcrumbs_smallA__1nnCI","resetA":"Breadcrumbs_resetA__2WVdM","disabled":"Breadcrumbs_disabled__2SCup"};